// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".razonSocial[data-v-5cbff5cf]{\n  font-size:90%;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
